import { $t } from '@/utils/languageAuto';

var render = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('my-modal', {
    attrs: {
      "width": 560,
      "data-sign": "shop_manage_unbind_account_modal",
      "title": _vm.t('解绑')
    },
    model: {
      value: _vm.visible,
      callback: function ($$v) {
        _vm.visible = $$v;
      },
      expression: "visible"
    }
  }, [_c('a-form-model', {
    attrs: {
      "label-col": {
        span: 6
      },
      "wrapper-col": {
        span: 16
      },
      "model": _vm.record
    }
  }, [_c('a-form-model-item', {
    attrs: {
      "fbu-analyse-name": $t("\u5E97\u94FA\u540D\u79F0"),
      "label": _vm.t('店铺名称')
    }
  }, [_c('a-input', {
    attrs: {
      "value": _vm.record.shop_name,
      "disabled": ""
    }
  })], 1), _c('a-form-model-item', {
    attrs: {
      "fbu-analyse-name": $t("\u5F53\u524D\u7ED1\u5B9A\u4E3B\u4F53"),
      "label": _vm.t('当前绑定主体')
    }
  }, [_c('a-input', {
    attrs: {
      "value": _vm.record.account_code + "-" + _vm.record.sign_body_name,
      "disabled": ""
    }
  })], 1)], 1), _c('div', {
    staticClass: "unbind-tips"
  }, [_c('p', {
    staticClass: "unbind-tips-title"
  }, [_vm._v(_vm._s(_vm.t('解绑影响')))]), _c('p', [_vm._v("1. " + _vm._s(_vm.t('系统将清除该店铺在「店铺默认主体」中的所有国家映射配置；')))]), _c('p', [_vm._v("2. " + _vm._s(_vm.t('历史已下单、已产生未出账单据仍按原账户正常扣费，不受影响；')))]), _c('p', [_vm._v("3. " + _vm._s(_vm.t('解绑后该店铺无法再用于新订单、新费用归属；')))]), _c('p', [_vm._v("4. " + _vm._s(_vm.t('如需重新使用，需重新绑定主体并配置国家映射。')))])]), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('a-button', {
    attrs: {
      "data-permission": "shop_manage_unbind_cancel",
      "id": "shop_manage_unbind_cancel",
      "data-sign": "shop_manage_unbind_cancel",
      "fbu-analyse-name": $t("\u53D6\u6D88")
    },
    on: {
      "click": function ($event) {
        _vm.visible = false;
      }
    }
  }, [_vm._v(_vm._s(_vm.t('取消')))]), _c('a-button', {
    attrs: {
      "type": "primary",
      "danger": "",
      "loading": _vm.saveLoading,
      "data-permission": "shop_manage_unbind_confirm",
      "id": "shop_manage_unbind_confirm",
      "data-sign": "shop_manage_unbind_confirm",
      "fbu-analyse-name": $t("\u786E\u8BA4\u89E3\u7ED1")
    },
    on: {
      "click": _vm.handleOk
    }
  }, [_vm._v(_vm._s(_vm.t('确认解绑')))])], 1)], 1);
};

var staticRenderFns = [];
export { render, staticRenderFns };